import { render, staticRenderFns } from "./release.vue?vue&type=template&id=5cd4bc38&scoped=true"
import script from "./release.vue?vue&type=script&lang=ts"
export * from "./release.vue?vue&type=script&lang=ts"
import style0 from "./release.vue?vue&type=style&index=0&id=5cd4bc38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd4bc38",
  null
  
)

export default component.exports